import { render, staticRenderFns } from "./banner.vue?vue&type=template&id=3988e363&scoped=true"
import script from "./banner.vue?vue&type=script&lang=ts"
export * from "./banner.vue?vue&type=script&lang=ts"
import style0 from "./banner.vue?vue&type=style&index=0&id=3988e363&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3988e363",
  null
  
)

export default component.exports